import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  border-top: 1px solid ${({ theme }) => theme.newColors["gray-400"]};
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 1.5rem 0;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 1rem 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;

  padding-top: 1.5rem;
`;

export const Step2Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    gap: 1rem;
  }
`;

export const TotalResultsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  margin: 0 auto;
  gap: 1rem;

  background-color: ${({ theme }) => theme.newColors["white"]};
  border: 1px solid ${({ theme }) => theme.newColors["blue-500"]};
  border-radius: 0.5rem;

  p {
    font-size: ${({ theme }) => theme.fontSize.XS};
    font-weight: ${({ theme }) => theme.fontWeight.Bold};
  }
`;

export const CSVContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: ${({ theme }) => theme.fontSize.XXXS};
    color: ${({ theme }) => theme.newColors["gray-900"]};
  }

  button {
    border: none;
    background: none;
    text-decoration: underline;
    cursor: pointer;

    font-size: ${({ theme }) => theme.fontSize.XXXS};
    color: ${({ theme }) => theme.newColors["blue-500"]};
    font-weight: ${({ theme }) => theme.fontWeight.Bold};

    &:disabled {
      color: ${({ theme }) => theme.newColors["gray-500"]};
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.newColors["blue-700"]};
    }
  }
`;

export const Step3Container = styled.div`
  color: ${({ theme }) => theme.newColors["gray-900"]};

  span {
    color: ${({ theme }) => theme.newColors["gray-900"]};
    font-weight: ${({ theme }) => theme.fontWeight.Bold};
  }

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
  }
`;

export const Step4Container = styled.div`
  color: ${({ theme }) => theme.newColors["gray-900"]};
`;

export const ResponsiveButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  padding-top: 1rem;

  button {
    height: 2.5rem;
    width: 100%;
  }
`;

export const BackButton = styled.div`
  margin-right: auto;
`;

export const ResponsiveButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const PreLineText = styled.p`
  white-space: pre-line;
`;
